/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact-form-dialog{width:100vw}.contact-form-dialog .mat-dialog-container{padding:0}.contact-form-dialog .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial}.contact-form-dialog .mat-dialog-container .toolbar-bottom{height:auto}.contact-form-dialog .mat-dialog-content{max-height:70vh;margin:0;padding:0}.contact-form-dialog .min-h-60-vh{min-height:60vh}.contact-form-dialog .address-container-right{border-left:1px solid #949494;height:100%;padding:0 24px}"];
export { styles as styles };
